export const GLOBALS = {
  TESTING: false,
  BUILD_ENV: "production",
  NAME: "Files",
  URL: "https://files.cinesend.com",
  API_URL: "https://api.cinesend.com/api",
  FILES_URL: "https://files.cinesend.com",
  ACCOUNTS_URL: "https://accounts.cinesend.com",  
  PUSHER_KEY: "d9783f156b21b5e86f7f",
  PUSHER_DEBUG: false,
  AWS_ACCELERATED_ENDPOINT: "https://cinesendcontainer.s3-accelerate.amazonaws.com"
}
